import { render, staticRenderFns } from "./47cailizhi.vue?vue&type=template&id=c835f69c&"
import script from "./47cailizhi.vue?vue&type=script&lang=js&"
export * from "./47cailizhi.vue?vue&type=script&lang=js&"
import style0 from "./47cailizhi.vue?vue&type=style&index=0&id=c835f69c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports